module.exports = __webpack_public_path__ + "img/share.6de41caf.svg";